import { render, staticRenderFns } from "./FormationGpec.vue?vue&type=template&id=8b5ce7fe&"
import script from "./FormationGpec.vue?vue&type=script&lang=js&"
export * from "./FormationGpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports